module.exports = __webpack_public_path__ + "static/media/traffic-yes.93fd5640.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nxbus/traffic-yes.svg
// module id = 784
// module chunks = 0